export enum INTERNAL_POST_LINK_SCOPE_LABEL {
    post = 'post',
    chapter = 'chapter',
    section = 'section',
}

export default INTERNAL_POST_LINK_SCOPE_LABEL;
